import {
  Button,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { useState } from "react";
import { LSTIconMapping } from "../../constants/common";

const FutureAirdrops = ({
  airdrops,
}: {
  airdrops: {
    id: number;
    asset_name: string;
    icon_path: string | null;
    release_date: string;
  }[];
}) => {
  const [expanded, showExpanded] = useState(false);

  const showViewMore = airdrops.length > 3 && !expanded;

  const visibleAirdrops = expanded ? airdrops : airdrops.slice(0, 3);
  return (
    <Flex gap="1rem" direction="column" flex={1}>
      <Text
        color="textPrimary"
        fontWeight={600}
        fontSize={{ base: "16px", md: "20px" }}
        lineHeight="24px"
      >
        Future Airdrops
      </Text>
      <Flex
        padding={{ base: "1rem", md: "2rem 2.5rem" }}
        backgroundColor="white"
        borderRadius="1.5rem"
        direction="column"
        gap="1rem"
      >
        <Table variant="unstyled" color="textPrimary">
          {/* <Show above="md"> */}
          <Thead>
            <Tr>
              <Th pl={1}>Asset</Th>
              <Th pl={1} textAlign={"right"}>
                Release Date
              </Th>
            </Tr>
          </Thead>
          {/* </Show> */}
          <Tbody>
            {visibleAirdrops.map((airdrop, index) => (
              <Tr key={index}>
                <Td
                  pl={1}
                  fontSize={{ base: "12px", md: "14px" }}
                  fontWeight={{ base: 400, md: 400 }}
                >
                  <Flex gap="0.5rem" alignItems="center">
                    {(LSTIconMapping[airdrop?.asset_name] ||
                      airdrop?.icon_path) && (
                      <BaseImage
                        src={
                          airdrop?.icon_path ||
                          LSTIconMapping[airdrop?.asset_name]
                        }
                        height={20}
                        width={20}
                        alt={airdrop?.asset_name}
                      />
                    )}
                    {airdrop?.asset_name}
                  </Flex>
                </Td>
                <Td
                  pl={1}
                  fontSize={{ base: "12px", md: "14px" }}
                  fontWeight={{ base: 400, md: 400 }}
                  textAlign={"right"}
                >
                  {airdrop?.release_date}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        {showViewMore && (
          <Button
            border="1px solid #B6DFDF"
            bg="#FFFFFF"
            color="#075A5A"
            _hover={{
              bg: "#FFFFFF",
            }}
            width="fit-content"
            onClick={() => showExpanded(true)}
          >
            View More
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
export default FutureAirdrops;
